import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';


function ProductTableBestGICRatesMoreDetails({
    minimumInvestment,
    isCDIC,
    redeemable,
    interestCompoundTerm,
    interestPaidTerm,
    ...otherProps
}) {
    return (
        <div {...otherProps}>
            <dl>
                <div className={DEFINITION_LIST_CLASSES}>
                    <dt className={TERM_CLASSES}>
                        <FormattedMessage
                            id="web-components.best-gics.more-details.minimum-investment.label"
                            defaultMessage="Minimum investment"
                        />
                    </dt>
                    <dd className={DEFINITION_CLASSES}>
                        <FormattedNumber
                            value={minimumInvestment}
                            format="CAD0"
                        />
                    </dd>
                </div>

                <div className={DEFINITION_LIST_CLASSES}>
                    <dt className={TERM_CLASSES}>
                        <FormattedMessage
                            id="web-components.best-gics.more-details.insurance.label"
                            defaultMessage="Insurance"
                        />
                    </dt>
                    <dd className={DEFINITION_CLASSES}>
                        <FormattedMessage
                            id="web-components.best-gics.more-details.insurance.value"
                            defaultMessage={`{isCDIC, select,
                                true {CDIC eligible}
                                other {Provincially insured}
                            }`}
                            values={{ isCDIC: isCDIC }}
                        />
                    </dd>
                </div>

                <div className={DEFINITION_LIST_CLASSES}>
                    <dt className={TERM_CLASSES}>
                        <FormattedMessage
                            id="web-components.best-gics.more-details.redeemable.label"
                            defaultMessage="Redeemable"
                        />
                    </dt>
                    <dd className={DEFINITION_CLASSES}>
                        <FormattedMessage
                            id="web-components.best-gics.more-details.redeemable.value"
                            defaultMessage={`{isRedeemable, select,
                                true {yes}
                                other {no}
                            }`}
                            values={{ isRedeemable: redeemable }}
                        />
                    </dd>
                </div>

                <div className={DEFINITION_LIST_CLASSES}>
                    <dt className={TERM_CLASSES}>
                        <FormattedMessage
                            id="web-components.best-gics.more-details.interest-compounded.label"
                            defaultMessage="Interest compounded"
                        />
                    </dt>
                    <dd className={DEFINITION_CLASSES}>
                        {interestCompoundTerm}
                    </dd>
                </div>

                <div className={DEFINITION_LIST_CLASSES}>
                    <dt className={TERM_CLASSES}>
                        <FormattedMessage
                            id="web-components.best-gics.more-details.interest-paid.label"
                            defaultMessage="Interest paid"
                        />
                    </dt>
                    <dd className={DEFINITION_CLASSES}>
                        <FormattedMessage
                            id="web-components.best-gics.more-details.redeemable.value"
                            defaultMessage={`{interestPaidTerm, select,
                                annually {annually}
                                other {at maturity}
                            }`}
                            values={{ interestPaidTerm: interestPaidTerm }}
                        />
                    </dd>
                </div>
            </dl>
        </div>
    );
}

ProductTableBestGICRatesMoreDetails.propTypes = {
    minimumInvestment: PropTypes.number.isRequired,
    isCDIC: PropTypes.bool.isRequired,
    redeemable: PropTypes.bool.isRequired,
    interestCompoundTerm: PropTypes.string.isRequired,
    interestPaidTerm: PropTypes.string.isRequired,
};

const DEFINITION_LIST_CLASSES = 'rh-display-flex rh-flex-nowrap rh-align-items-center rh-text-s rh-my-0_25';
const TERM_CLASSES = 'rh-mr-0_5';
const DEFINITION_CLASSES = 'rh-ml-auto weight-medium';


export default ProductTableBestGICRatesMoreDetails;
